import { useState, useEffect } from 'react';
import './NoInternetScreen.css';
import Logo from '../assets/logo192.png'

export default function NoInternetScreen() {
    const [retrying, setRetrying] = useState(false);
    const [dots, setDots] = useState('');

    /* Animated dots while retrying */
    useEffect(() => {
        if (!retrying) { setDots(''); return; }
        const id = setInterval(() => setDots(d => (d.length >= 3 ? '' : d + '.')), 400);
        return () => clearInterval(id);
    }, [retrying]);

    const handleRetry = () => {
        setRetrying(true);
        /* Give the browser ~2 s to re-detect connectivity, then reset */
        setTimeout(() => setRetrying(false), 2000);
    };

    return (
        <div className="no-internet-overlay">
            {/* Top announce bar — same as the real app */}
            <div className="announce-bar">« Jésus, j'ai confiance en Toi »</div>

            <div className="no-internet-body">
                {/* Brand */}
                <div className="no-internet-brand">
                    <h3 className="no-internet-brand-name fw-semibold fs-4">MINISTÈRE CATHOLIQUE MISÉRICORDE</h3>
                </div>

                {/* Decorative divider */}
                <div className="page-title-divider" style={{ margin: '20px 0' }}>
                    <span className="page-title-line" />
                    <span className="page-title-diamond">✦</span>
                    <span className="page-title-line" />
                </div>

                {/* Wifi-off icon */}
                <div className="no-internet-icon-wrap">
                    <svg
                        className="no-internet-icon"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                    >
                        <line x1="2" y1="2" x2="22" y2="22" />
                        <path d="M8.5 16.5a5 5 0 0 1 7 0" />
                        <path d="M2 8.82a15 15 0 0 1 4.17-2.65" />
                        <path d="M10.66 5c4.01-.36 8.14.9 11.34 3.76" />
                        <path d="M16.85 11.25a10 10 0 0 1 2.22 1.68" />
                        <path d="M5 12.85A10 10 0 0 1 9.33 10" />
                        <line x1="12" y1="20" x2="12.01" y2="20" />
                    </svg>
                </div>

                {/* Heading */}
                <h1 className="no-internet-title">Connexion introuvable</h1>

                {/* Body text */}
                <p className="no-internet-message">
                    Vérifiez votre connexion Wi-Fi ou données mobiles,<br />
                    puis réessayez.
                </p>

                {/* Retry button */}
                <button
                    className={`btn-mcm no-internet-retry${retrying ? ' retrying' : ''}`}
                    onClick={handleRetry}
                    disabled={retrying}
                >
                    {retrying ? `RECONNEXION EN COURS${dots}` : 'RÉESSAYER'}
                </button>
            </div>

            {/* Footer — same as the real app */}
            <footer className="user-footer" style={{ flexShrink: 0 }}>
                <span>© {new Date().getFullYear()} Ministère Catholique Miséricorde — MCM. Tous droits réservés.</span>
            </footer>
        </div>
    );
}
